import { apiClient } from '../../gateways/api'

export { importAanvraag }

const importAanvraag = async ({ aanvraagID }: { aanvraagID: string }) => {
  await apiClient({
    url: `/rest/beheer/aanvraag/${aanvraagID}/import`,
    method: 'POST',
  })
}
